import { AsyncState } from 'widgets-for-react'
import { loadCount } from './paginationApi'

export type PaginationState = AsyncState<number>

export const initialPaginationState = (
  countApicall: () => Promise<any>,
  dataLayerData?: { tab: string; term: string }
): PaginationState => loadCount(countApicall, dataLayerData)
